<template>
  <div>
    <div style="display: flex; align-items: center; flex-direction: column;">
      <div style="width: 100%;">
        <b-form-group :label="label">
          <div
            :class="{'desabilitar-inputs': disabled}"
            style="display: flex; align-items: center; justify-content: center; "
          >
            <file-upload
              v-show="!textArquivo && !valor[0]"
              ref="upload"
              v-model="valor"
              :style="disabled ? 'opacity:1' : ''"
              :input-id="idUpload"
              class="btn btn-primary btn-sm mr-50"
              :accept="'.pfx'"
              :multiple="false"
              @input="selecionado"
              @input-filter="inputFilter"
            >
              Anexar certificado
            </file-upload>
          </div>
        </b-form-group>
      </div>
      <div
        v-if="valor[0] || textArquivo"
        class="container-text-certificado"
      >
        <div
          class="text-certificado"
          @click="baixarArquivo"
        >
          Arquivo: {{ textArquivo ? textArquivo : valor[0].name }}
        </div>
        <div
          class="remove-certificado"
          @click="removeArquivo()"
        >
          <i
            class="fa-solid fa-xmark"
          />
        </div>
      </div>
    </div>

    <validation-observer ref="validacaoCertificado">
      <div style="border: 1px solid gainsboro; border-radius: 10px; padding: 1rem;">
        <b-row class="mt-1">
          <b-form-group
            label="Tipo"
            class="col-2"
          >
            <validation-provider
              #default="{ errors }"
              :rules="valueInner.emProcesso ? '' : 'required'"
              name="Tipo"
            >
              <b-select
                v-model="valueInner.tipo"
                :disabled="disabledTipo || disabledInputsGeral || disabledUserData"
                @change="changeTipo"
              >
                <option
                  v-for="index in tipoOption"
                  :key="index.value"
                  :value="index.value"
                >{{ index.text }}</option>
              </b-select>
              <small
                v-if="errors[0]"
                class="text-danger"
              >O campo Tipo é obrigatório</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="Modelo"
            class="col-2"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Modelo"
            >
              <b-select
                v-model="valueInner.modelo"
                :disabled="disabledModelo || disabledInputsGeral || disabledUserData"
                :class="errors.length > 0 ? 'is-invalid' : null"
                @change="changeTipo"
              >
                <option
                  v-for="$index in modeloOption"
                  :key="$index.value"
                  :value="$index.value"
                >{{ $index.text }}</option>
              </b-select>
              <small
                v-if="errors[0]"
                class="text-danger"
              >Modelo é obrigatório</small>
            </validation-provider>
          </b-form-group>
          <b-col cols="4">
            <b-form-group label="Senha">
              <senha-input
                ref="senhaCertificado"
                v-model="valueInner.senha"
                :blur-function="validarCertificado"
                :required="!valueInner.emProcesso"
                :disabled="disabledInputsGeral || disabledUserData || disabledSenha"
              />
              <small
                v-if="senhaIncorreta"
                class="text-danger"
              >
                Senha incorreta
              </small>
            </b-form-group>
          </b-col>
          <b-col cols="2">
            <b-form-group label="Data de Vencimento">
              <validation-provider
                #default="{ errors }"
                :rules="valueInner.emProcesso ? '' : 'required'"
              >
                <data-input
                  v-model="valueInner.dataDeVencimento"
                  :disabled=" disabledVencimento || disabledInputsGeral || disabledUserData"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  style="border-color: red;"
                />
                <small
                  v-if="errors[0]"
                  class="text-danger"
                >Vencimento é obrigatório</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-form-group
            label="Por Procuração"
            class="col-2"
          >
            <b-select
              v-model="valueInner.porProcuracao"
              :disabled="disabledProcuracao || disabledUserData"
            >
              <option
                v-for="index in procuracaoOption"
                :key="index.value"
                :value="index.value"
              >{{ index.text }}</option>
            </b-select>
          </b-form-group>
        </b-row>
      </div>
    </validation-observer>
    <div
      class="mb-1 mt-50"
      style="display: flex; align-items: center; justify-content: space-between;"
    >
      <div
        style="display: flex; align-items: center; justify-content: space-between;"
      >
        <b-form-checkbox
          v-model="valueInner.emProcesso"
          :disabled="disabledEmProcesso"
          style="margin-right: 8rem;"
          @change="emProcesso"
        >
          Em Processo
        </b-form-checkbox>
        <b-form-checkbox
          v-model="valueInner.naoEnviarAlerta"
          :disabled="disabledUserData"
        >
          Dispensar Alerta de Vencimento
        </b-form-checkbox>
      </div>
      <div v-if="valueInner.dataDeAlteracaoNaoEviarAlerta">
        <span style="margin-right: 5px;">
          Usuário: {{ valueInner.usuAlteracaoDispensado }}
        </span>
        <span>
          Data: {{ valueInner.dataDeAlteracaoNaoEviarAlerta }}
        </span>
      </div>
    </div>
  </div>
</template>
<style>
.container-text-certificado {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #c1af1d;
  border-radius: 5px;
  color: #ffff;
  margin-bottom: 1rem;
}
.text-certificado {
  cursor: pointer;
  padding: 0 5px 0 5px;
  margin-bottom: 0;
}
.remove-certificado {
  cursor: pointer;
  padding: 0 5px 0 5px;
}
</style>

<script>
/* eslint-disable */
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import FileUpload from 'vue-upload-component'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import { canDownloadECPF, canDownloadECnpj } from '@/auth/utils'
import api from '@/app-modulo/comuns/empresa/shared/services/api'
import apiCertificado from '@/app-modulo/comuns/certificado/shared/services/api.js'
import ultis from '@/@core/utils/file-utils'

export default {
  name: 'UploadCertificado',
  components: {
    FileUpload,
    FeatherIcon,
    ValidationProvider,
    ValidationObserver,
    DataInput: () => import('@/shared/components/data-input/DataInput.vue'),
    SenhaInput: () => import('@/shared/components/senha-input/SenhaInput.vue'),
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    idUpload: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledInputs: {
      type: Boolean,
      default: false,
    },
    disabledUserData: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      now: new Date(),
      disabledTipo: false,
      disabledSenha: false,
      disabledModelo: true,
      disabledEmProcesso: false, 
      disabledProcuracao: true,
      disabledVencimento: true,
      disabledInputsGeral: false,
      fileName: '',
      valor: [],
      url: '',
      mostrarVisualizacao: false,
      valueAttr: '',
      valueInner: {},
      senhaIncorreta: false,
      anexoVencido: false,
      anexoExecao: false,
      arquivoExistente: null,
      valorInicialNaoEnviarAlerta: false,
      tipoOption: [{ value: 1, text: 'A1' }, { value: 2, text: 'A3' }],
      modeloOption: [ { value: 1, text: 'e-CNPJ' }, { value: 2, text: 'e-CPF' }],
      procuracaoOption: [ { value: false, text: 'Não' }, { value: true, text: 'Sim' }],
    }
  },
  computed: {
    textArquivo: {
      get() {
        return this.valueAttr ? this.valueAttr : this.text
      },
      set(newValue) {
        this.valueAttr = newValue
        return this.valueAttr
      },
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
        this.arquivo(this.valueInner.certificado)
        if( value.modelo === 1 && value.tipo !== 0){
          this.disabledProcuracao = false
        }
        if(value.tipo === 1){
          this.disabledEmProcesso = true
        }
        if(value.emProcesso){
          this.disabledTipo = true
          this.disabledSenha = true
          this.disabledVencimento = true
          this.disabledProcuracao = true
        }
      }
    },
    text(val, oldVal) {
      if (val !== oldVal) {
        this.valueAttr = val
      }
    },
    disabledInputs(value, oldValue) {
        if (value !== oldValue) {
          this.disabledInputsGeral = value
      }
    }
  },
  created() {
    this.valueInner = this.value
    if (this.valueInner) {
      this.arquivo(this.valueInner.certificado)
      this.valorInicialNaoEnviarAlerta = this.valueInner.naoEnviarAlerta
    }
    if(this.$route.path.indexOf('editar') > 0){
      this.disabledModelo = false
      this.disabledVencimento = false
    }
  },
  methods: {
    arquivo(value) {
      if (value ) {
        const binary = atob(value)
        const array = []
        for (let i = 0; i < binary.length; i += 1) {
          array.push(binary.charCodeAt(i))
        }
        const file = new Blob([new Uint8Array(array)], { type: 'application/pfx' })
        this.arquivoExistente = file
        this.$refs.upload.add(file)
      }
    },
    baixarArquivo() {
      let downloadFeito = false
      if ((this.valueInner.modelo === 1 && canDownloadECnpj()) || (this.valueInner.modelo === 2 && canDownloadECPF())) {
        ultis.downloadCertificado(this.valueInner.certificadoArquivo, this.text)
        downloadFeito = true
      } else {
        downloadFeito = false
        this.$erro('Você não tem permissão para realizar o download! Contate o administrador do sistema.')
      }
      if(downloadFeito){
        this.AddHistoricos(this.valueInner.id)
      }
    },

    AddHistoricos(id) {
      const tela = 'certificados'
      apiCertificado.addHistorico(id, tela)
        .then(() => {
        })
        .catch(err => {
          this.$erro(err)
        })
    },
    
    validarCertificado() {
      this.senhaIncorreta = false
      if (this.valueInner.nome !== '' && (this.valueInner.senha && this.valueInner.senha !== '') && this.valueInner.tipo != 2) {
        const formData = new window.FormData()
        const fileCertificado = this.valor[0]
        formData.append('file', fileCertificado.file, fileCertificado.filename || fileCertificado.name)
        formData.append('body', this.valueInner.senha)
        this.valueInner.certificadoArquivo = this.arquivo()
        
        apiCertificado.validaCertificado(formData)
          .then(payload => {
            const data = new Intl.DateTimeFormat('pt-BR').format(new Date(payload.data.dataDeVencimento))
            
            this.$set(this.valueInner, 'dataDeVencimento', data)
            this.$set(this.valueInner, 'modelo', payload.data.modelo)
            this.$set(this.valueInner, 'vinculadas',  payload.data.vinculadas)
            this.$set(this.valueInner, 'naoVinculadas', payload.data.naoVinculadas)
            this.$set(this.valueInner, 'totalVinculadas', payload.data.vinculadas.length)
            this.$set(this.valueInner, 'totalNaoVinculadas', payload.data.naoVinculadas.length)
            this.desabilitarModeloTipo(this.valueInner)
            this.$emit('data-certificados', this.valor[0])
            if(payload.data.modelo === 2 && payload.data.tipo === 2) {
              this.$set(this.valueInner, 'porProcuracao', false)
              this.disabledProcuracao = true
            }
            if( payload.data.tipoCertificado === 1) {
              this.disabledInputsGeral = true
            }
          })
          .catch(err => {
            this.$emit('data-certificados', this.valor[0])
            const resolved = this.$resolveError(err)
            const message = resolved.detail || resolved.title || err.message || ''
            this.senhaIncorreta = message === 'Senha incorreta!'
            this.anexoVencido = message === 'O certificado está vencido!'
            this.$handleError(err)
          })
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      const file = newFile
      if (file) {
        if (this.isDangerFile(file.name)) {
          this.$erro('Arquivo não permitido')
          return prevent()
        }

        if (this.certificado && !this.allowExtension(file.name, 'pfx|PFX|p12|P12')) {
          this.$erro('Apenas arquivo pfx é permitido')
          return prevent()
        }
      }
      return null
    },
    selecionado() {
      if (this.valor[0] && this.valor[0].name !== 'unknown') {
        this.textArquivo = ''
        this.fileName = this.valor[0].name
        this.$set(this.valueInner, 'senha', null)
        this.$set(this.valueInner, 'dataDeVencimento', null)
        this.$set(this.valueInner, 'tipo', 1)
        this.$set(this.valueInner, 'porProcuracao', false)
        this.$set(this.valueInner, 'nome', this.valor[0].name)
        this.$emit('selecionado', this.fileName)
        this.$set(this.valueInner, 'emProcesso', false)
        this.$refs.senhaCertificado.focusInput()
        this.disabledModelo = false
        this.disabledEmProcesso = true
        this.emProcesso()
        
      } else {
        this.fileName = ''
      }
    },
    initialDados() {
      this.$set(this.valueInner, 'modelo', 0)
      this.$set(this.valueInner, 'tipo', 0)
      this.$set(this.valueInner, 'porProcuracao', false)
    },
    removeArquivo() {
      if(!this.disabledUserData){
        if (this.valor[0]) {
          this.$refs.upload.remove(this.valor[0])
        }
        this.clearTabelaVinculo()

        this.$set(this.valueInner, 'nome', '')
        this.$set(this.valueInner, 'dataDeVencimento', '') 
        this.$set(this.valueInner, 'senha', null) 
        this.$set(this.valueInner, 'modelo', 0) 
        this.$set(this.valueInner, 'tipo', 0)
        
        this.fileName = ''
        this.urlArquivo = ''
        this.textArquivo = ''
        this.$emit('removido')
        this.disabledProcuracao = false   
        this.disabledInputsGeral = false
        this.disabledEmProcesso = false
      }
    },
    isDangerFile(fileName) {
      if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(fileName)) {
        return true
      }
      // Filter php html js file
      if (/\.(php5?|html?|jsx?)$/i.test(fileName)) {
        return true
      }

      return false
    },
    allowExtension(fileName, extensions) {
      const regex = new RegExp(`^.*\\.(${extensions})$`)
      if (!regex.test(fileName)) {
        return false
      }
      return true
    },
    newFileform(){
      const formData = new window.FormData()
        const fileCertificado = this.valor[0]
        formData.append('file', fileCertificado.file, fileCertificado.filename || fileCertificado.name)
        formData.append('body', this.valueInner)
    },
    clearModelo() {
      this.$set(this.valueInner, 'modelo', null)
      this.$set(this.valueInner, 'senha', null) 
    },
    desabilitarModeloTipo(value){
      this.disabledProcuracao = value.modelo == 2
    },
    changeTipo() {
      if(! this.disabledInputsGeral){
        this.clearTabelaVinculo()
      }
      if(this.valueInner.tipo === 1){
        this.disabledProcuracao = false
        this.disabledModelo = false
      }else if ( !this.valueInner.emProcesso) {
        this.disabledVencimento = false
      }
      if(this.valueInner.modelo === 2){
        this.$set(this.valueInner, 'porProcuracao', false) 
        this.disabledProcuracao = true
      }
      if(this.valueInner.tipo === 2 && this.valueInner.modelo === 1){
        this.disabledProcuracao = false
        this.$set(this.valueInner, 'porProcuracao', false) 
      }
      if(this.valueInner.tipo === 2 && (!this.valueInner.modelo || this.valueInner.modelo === 0)){
        this.disabledVencimento = false
        this.disabledModelo = false
        if(this.valor[0]){
          this.removeArquivo()
        }
      }
      if((this.valueInner.tipo === 2 || (this.valueInner.tipo === 0 && this.valueInner.emProcesso)) && this.valueInner.modelo && !this.disabledModelo && ! this.disabledInputsGeral){
        apiCertificado.getDadosTabelaVinculo(this.valueInner.modelo)
        .then(payload => {
            this.$set(this.valueInner, 'vinculadas',  payload.data.vinculadas)
            this.$set(this.valueInner, 'naoVinculadas', payload.data.naoVinculadas)
            this.atualizaTotalNaoVinculadas(payload.data)
          })
          .catch(err => {
            this.$erro(err)
          })
      }
    },
    atualizaTotalNaoVinculadas(payload){
      if (payload.naoVinculadas.length > 0) {
        this.valueInner.totalNaoVinculadas = this.valueInner.naoVinculadas.length
      }
    },
    clearTabelaVinculo() {
      this.$set(this.valueInner, 'vinculadas', [])
      this.$set(this.valueInner, 'naoVinculadas', [])
      this.$set(this.valueInner, 'totalVinculadas', 0)
      this.$set(this.valueInner, 'totalNaoVinculadas', 0)
    },
    emProcesso() {
      if(this.valueInner.emProcesso){
      this.$set(this.valueInner, 'modelo', 1) 
      this.disabledModelo = false
      this.$set(this.valueInner, 'tipo', 0)
      this.changeTipo()
      this.disabledTipo = true
      this.disabledSenha = true
      this.disabledProcuracao = true
      this.disabledVencimento = true
      this.$set(this.valueInner, 'vinculadas', [])
      } else {
      this.disabledModelo = false
      this.disabledTipo = false
      this.disabledSenha = false
      this.disabledProcuracao = false
      this.disabledVencimento = false
      this.clearTabelaVinculo()
      }
      
    }
  },
}
</script>
